import React, { useContext, useEffect } from 'react';
import { useState, useRef } from 'react';
import { Container, Tab, Tabs, Table, Button, Card, ModalTitle, CardBody, ListGroup } from 'react-bootstrap';
import { BsBasketFill } from "react-icons/bs";
import Accordion from 'react-bootstrap/Accordion';
import { FaPlus } from "react-icons/fa";
import Modal from 'react-bootstrap/Modal';
import ProductCarousel from './ProductCarousel';
import ProductCarouselSep from './ProductCarouselSep';
import ImageZoom from './ImageZoom';
import "./Product_Fraga.css";
import imgNotFound from '../img/img_not_found.jpg'
import Load from './Load';
import { GetUserContext } from '../Context/GetUserContext';
import formats from '../controller/views/formats'
import aplications from '../controller/api/Aplications';
import products from '../controller/api/Product';

import { FaMinus } from "react-icons/fa";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import BtnIsCar from './BtnIsCar';
import BtnReposit from './BtnReposit';
import { BsCartCheckFill } from "react-icons/bs";


const Product_Fraga = ({ sep, product }) => {
    const { size, fetchTimestampApp, setFetchTimestampApp, setShow, filterEstoque, setFilterEstoque, setInsReposit, isReposit, setQtdCar, axiosConfig, qtdTotal, setqtdTotal, fetchTimestamp, setFetchTimestamp } = useContext(GetUserContext);
    const [aplication, setAplication] = useState({});
    const [verifyAplication, setVerifyAplication] = useState(false)
    const Aplications = new aplications();
    const Produto = new products();

    //console.log(product);

    const idUser = JSON.parse(localStorage.getItem('user'))

    const [indexImg, setIndexImg] = useState(0);
    const [loadCross, setLoadCorss] = useState();
    const [showF, setShowF] = useState(false);


    const handleClose = () => {
        setShowF(false);
    }

    const handleCloseCurrentModal = () => {
        setShow(true);
        setShowF(false);
    }
    const [prodIsCar, setProdIsCar] = useState(false);
    const [qtdProdEsto, setQtdProdEsto] = useState(0);

    const [idProdCurrentCar, setIdProdCurrentCar] = useState([])

    useEffect(() => {
        if (!product?.Produtos_Estoques?.[0]?.ID_Produto_Estoque) return;

        const allProds = Produto.getAllProdsLocalStorage(idUser.Company_ID) || [];
        const ids = allProds.map(item => item?.ID_Produto_Estoque);
        setIdProdCurrentCar(ids);
    }, [product, fetchTimestampApp, idUser.Company_ID]);

    const handleShowF = () => {
        setShowF(true);

        Aplications.getAplications(product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.id)
            .then(response => {

                if (response?.vehicles == undefined) {
                    setVerifyAplication(true)

                } else {
                    setVerifyAplication(false)
                    setAplication(response)
                }
            })
    };

    const produtosSimilaresRef = useRef(null);


    const [isZoomVisible, setIsZoomVisible] = useState(false);
    const [zoomPosition, setZoomPosition] = useState({ backgroundPosition: '0% 0%' });
    const handleMouseEnter = () => setIsZoomVisible(true);
    const handleMouseLeave = () => setIsZoomVisible(false);

    const handleMouseMove = (e) => {
        const { left, top, width, height } = e.target.getBoundingClientRect();
        const x = ((e.clientX - left) / width) * 100;
        const y = ((e.clientY - top) / height) * 100;
        setZoomPosition({ backgroundPosition: `${x}% ${y}%` });
    };

    const changeFoto = (e) => {
        setIndexImg(e)
    }
    const [dataAddProdCar, setDataAddProdCar] = useState(null);

    const handleAddProdCart = (value) => {
        const storedItems = JSON.parse(localStorage.getItem(`itemCardProd${idUser.Company_ID}`)) || [];
        const cartArray = Array.isArray(storedItems) ? storedItems : [];
        const itemExists = cartArray.some(item => item.ID_Produto_Estoque === product?.Produtos_Estoques?.[0]?.ID_Produto_Estoque);

        if (itemExists) {
            return "⚠️ Item já existe no carrinho!"
        }

        const data = {
            Company_ID: idUser.Company_ID,
            ID_Produto_Estoque: product?.Produtos_Estoques?.[0]?.ID_Produto_Estoque,
            Qtd_Produto: 1,
            Preco_Produto: parseFloat(product?.Preco_4),
            Estoque_Carrinho: 1,
            ValorQtd: parseFloat(product?.Preco_4),
            product: product
        };

        const updatedItems = [...cartArray, data];
        localStorage.setItem(`itemCardProd${idUser.Company_ID}`, JSON.stringify(updatedItems));
        setFetchTimestampApp(Date.now());
    };

    useEffect(() => {
        if (!dataAddProdCar) return;

        Produto.addProdCar(dataAddProdCar)
            .then(response => {
                setQtdProdEsto(response.data.Estoque_Carrinho);
            })
            .catch(err => {
                console.error(err);
            });
    }, [dataAddProdCar]);

    const [activeKey, setActiveKey] = useState("0");
    const isActive = (key) => activeKey === key;

    return (

        <>
            <Card className='product' >
                <Card.Header className='photo-product'>
                    {
                        product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.[0]?.thumbnailUrl == undefined ?
                            (<img onClick={() => handleShowF(true)} src={imgNotFound} />) :
                            (<img onClick={() => handleShowF(true)} src={product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0].product?.images[0]?.thumbnailUrl} />)
                    }
                </Card.Header >
                <Card.Body className='area-description-product' onClick={() => handleShowF(true)}>
                    <div className='title-product'>{product?.Nome_Produto} </div>
                    <div className='text-product'>Referência: <strong>{product?.Referencia_Produto}</strong></div>


                    {
                        sep ? (<></>) :
                            (
                                parseInt(product?.Produtos_Estoques?.[0]?.Qtd_Estoque) <= 0 ? (
                                    <div className="text-product">Esgotado!</div>
                                ) : (
                                    <div className="text-product">

                                        Em Estoque: <strong>{parseInt(product?.Produtos_Estoques?.[0]?.Qtd_Estoque)}</strong>

                                    </div>
                                )
                            )
                    }

                </Card.Body>

                {
                    size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
                        (
                            <Card.Footer className='area-price-product'>
                                {idProdCurrentCar.includes(product?.Produtos_Estoques?.[0]?.ID_Produto_Estoque) ?
                                    (<div className=' d-flex align-items-center justify-content-between '>
                                        <div className='icon-add-car-market-in-car'>
                                            <strong>R$ </strong>
                                            <strong>{formats.formatPrice(product?.Preco_4)}</strong>
                                        </div>
                                        <button className='btn btn-success'><BsCartCheckFill /></button>

                                    </div>) :
                                    (qtdProdEsto == 0 ? (
                                        parseInt(product?.Produtos_Estoques?.[0]?.Qtd_Estoque) <= 0 ? (


                                            <div>
                                                <strong>R$ </strong>
                                                <strong>{formats.formatPrice(product?.Preco_4)}</strong>
                                            </div>


                                        ) : (
                                            <div
                                                onClick={(e) => { handleAddProdCart(e.currentTarget.dataset.value) }}
                                                data-value={product?.Produtos_Estoques?.[0]?.ID_Produto_Estoque}
                                                className='d-flex align-items-center icon-add-car-market'
                                                style={{ backgroundColor: "transparent" }}
                                            >
                                                <div className='icon-add-car-market'>
                                                    <strong>R$ </strong>
                                                    <strong>{formats.formatPrice(product?.Preco_4)}</strong>
                                                </div>
                                            </div>
                                        )
                                    ) : (
                                        <BtnIsCar insStock={parseInt(product?.Preco_4)} />
                                    ))
                                }



                            </Card.Footer>
                        )
                        :
                        (
                            <Card.Footer className='area-price-product'>
                                {idProdCurrentCar.includes(product?.Produtos_Estoques?.[0]?.ID_Produto_Estoque) ?
                                    (<div className=' bg-success icon-add-car-market-ok'>
                                        <BsCartCheckFill onClick={handleCloseCurrentModal} />
                                    </div>) :
                                    (qtdProdEsto == 0 ? (
                                        parseInt(product?.Produtos_Estoques?.[0]?.Qtd_Estoque) <= 0 ? (
                                            <div></div>
                                        ) : (
                                            <div
                                                onClick={(e) => { handleAddProdCart(e.currentTarget.dataset.value) }}
                                                data-value={product?.Produtos_Estoques?.[0]?.ID_Produto_Estoque}
                                                className='d-flex align-items-center icon-add-car-market'
                                                style={{ backgroundColor: "transparent" }}
                                            >
                                                <BsBasketFill />
                                                <FaPlus style={{ marginLeft: "3px" }} />
                                            </div>
                                        )
                                    ) : (
                                        <BtnIsCar insStock={parseInt(product?.Preco_4)} />
                                    ))
                                }


                                <div className='icon-add-car-market'>
                                    <strong>R$ </strong>
                                    <strong>{formats.formatPrice(product?.Preco_4)}</strong>
                                </div>
                            </Card.Footer>
                        )
                }
            </Card>

            {
                size?.categoria !== 'xlarge' && size?.categoria !== 'large' ?
                    (
                        <Modal show={showF} onHide={handleClose}
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            fullscreen
                        >
                            <Modal.Header className='container' closeButton>
                                <h5 >{product?.Nome_Produto}</h5>
                            </Modal.Header>

                            <Modal.Body className='container max-width-modal-product'  >
                                <div>
                                    <div className='area-fullscreen-product-image-mobile'>
                                        {
                                            product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images == null ?
                                                (<img src={imgNotFound} />) :
                                                (<img className='img-full' src={product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.[indexImg]?.imageUrl} />)
                                        }
                                    </div>

                                    <div className='area-photo-small-mobile'>
                                        {
                                            product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.map((img, index) => (
                                                <React.Fragment key={index}>
                                                    <div onMouseOver={(e) => { changeFoto(index) }}><img src={img?.thumbnailUrl} /></div>
                                                </React.Fragment>
                                            ))
                                        }
                                    </div>
                                    <br></br>

                                    {
                                        isZoomVisible && product?.images != null ?
                                            (<> </>) :
                                            (<div className='area-fullscreen-product-mobile '>
                                                <hr></hr>
                                                <br></br>
                                                <h1 className='price-mobile'>R$ {formats.formatPrice(product?.Preco_4)}</h1>
                                                <div>Vendido por: <strong className='text-secondary'>Auparts Distribuidora</strong></div>
                                                <div>Referência: <strong className='text-secondary'>{product?.Referencia_Produto}</strong> </div>
                                                <div>Fabricante: <strong className='text-secondary'>{product?.Fabricante?.Nome_Fabricante}</strong> </div>
                                                <div>Estoque: <strong className='text-secondary'>{parseInt(product?.Produtos_Estoques?.[0]?.Qtd_Estoque)}</strong></div>
                                                <br></br>
                                                {
                                                    sep ? (<></>) :
                                                        (
                                                            parseInt(product?.Produtos_Estoques?.[0]?.Qtd_Estoque) <= 0 ? (
                                                                <div className="text-product">Esgotado!</div>
                                                            ) : (
                                                                <div className='d-flex'>
                                                                    {
                                                                        idProdCurrentCar.includes(product?.Produtos_Estoques?.[0]?.ID_Produto_Estoque) ?
                                                                            (<>
                                                                                <div className=' bg-success icon-add-car-market-ok'>
                                                                                    <BsCartCheckFill onClick={handleCloseCurrentModal} />
                                                                                </div>
                                                                                <span className='desc-add-car'>Item adicionado no carrinho</span>
                                                                            </>
                                                                            ) :
                                                                            (<div onClick={handleAddProdCart} style={{ backgroundColor: "transparent" }} className='d-flex align-items-center   icon-add-car-market'>
                                                                                <Button size="lg w-100" variant='warning' >Comprar</Button>
                                                                            </div>)
                                                                    }
                                                                </div>
                                                            )
                                                        )
                                                }

                                            </div>)
                                    }
                                </div>

                                <hr></hr>

                                {
                                    verifyAplication ?
                                        (<Tabs
                                            defaultActiveKey="Aplicação"
                                            id="uncontrolled-tab-example"
                                            className="mb-3"
                                        >
                                            <Tab eventKey="Aplicação" title="Descrição">
                                                <div className='area-aplication-product' >
                                                    <Table striped>
                                                        <thead className='table-header'>
                                                            <tr> </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr>
                                                                <td className="table-cell-loading">{product?.Descricao_Auri}</td>
                                                            </tr>
                                                        </tbody>

                                                    </Table>
                                                </div>
                                            </Tab>
                                        </Tabs>)
                                        :
                                        (
                                            <Accordion activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                                                <Accordion.Item eventKey="0">
                                                    <Accordion.Header className={isActive("0") ? "active-acordeon" : ""}>
                                                        Aplicação
                                                    </Accordion.Header>
                                                    <Accordion.Body className='accordion-custom' >
                                                        {
                                                            aplication?.vehicles === undefined ? (
                                                                <div className="table-cell-loading">Carregando...</div>
                                                            ) : (
                                                                aplication?.vehicles
                                                                    ?.sort((a, b) => a?.name?.localeCompare(b?.name))
                                                                    ?.map((app, index) => (
                                                                        <div style={{ fontSize: ".8em" }} className='text-secondary form-control mb-2' key={index}>
                                                                            <span>{app?.brand}  </span>
                                                                            <span>{app?.name}  </span>
                                                                            <span>{app?.model}  </span>
                                                                            <span>{app?.engineName}  </span>
                                                                            <span>{app?.engineConfiguration}  </span>
                                                                            <span>{app?.startYear} - </span>
                                                                            <span>{app?.endYear}</span>

                                                                        </div>
                                                                    ))
                                                            )
                                                        }

                                                    </Accordion.Body>
                                                </Accordion.Item>

                                                <Accordion.Item eventKey="1">
                                                    <Accordion.Header className={isActive("1") ? "active-acordeon" : ""}>
                                                        Ficha Técnica
                                                    </Accordion.Header>
                                                    <Accordion.Body className='accordion-custom'>
                                                        {
                                                            aplication?.specifications?.map((spec, index) => (
                                                                <ListGroup key={index}>
                                                                    <ListGroup.Item className='mb-1' > {`${spec?.description}: `}<strong className='text-secondary'>{spec?.value}</strong></ListGroup.Item>
                                                                </ListGroup>


                                                            ))
                                                        }

                                                    </Accordion.Body>
                                                </Accordion.Item>

                                                <Accordion.Item eventKey="2">
                                                    <Accordion.Header className={isActive("2") ? "active-acordeon" : ""}>
                                                        Referência Cruzada
                                                    </Accordion.Header>
                                                    <Accordion.Body className='accordion-custom'>
                                                        <div className='similar-product-fullscreen'>
                                                            {
                                                                loadCross ?
                                                                    (<>Carregando...</>)
                                                                    : (<>

                                                                        <Table striped>
                                                                            <thead className='table-header'>
                                                                                <tr>
                                                                                    <th>Montadora</th>
                                                                                    <th>Código</th>
                                                                                </tr>
                                                                            </thead>
                                                                            <tbody>
                                                                                {

                                                                                    aplication?.crossReference?.length == 0 ?
                                                                                        (<tr>
                                                                                            <td className="table-cell-loading">Carregando...</td>
                                                                                        </tr>
                                                                                        ) :
                                                                                        (
                                                                                            aplication?.crossReference?.map((app, index) => (
                                                                                                <tr key={index}>
                                                                                                    <td>{app?.brand?.name}</td>
                                                                                                    <td className='text-right'>{app?.partNumber}</td>

                                                                                                </tr>
                                                                                            ))
                                                                                        )
                                                                                }

                                                                            </tbody>
                                                                        </Table>

                                                                    </>)

                                                            }

                                                        </div>
                                                    </Accordion.Body>
                                                </Accordion.Item>
                                            </Accordion>
                                        )
                                }


                                <br></br>
                                <hr></hr>
                            </Modal.Body>

                        </Modal >

                    )
                    :
                    (
                        <Modal show={showF} onHide={handleClose}
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                            className="custom-width-modal"
                        >
                            <Modal.Header className='container' closeButton>
                                <Modal.Title>{product?.Nome_Produto}</Modal.Title>
                            </Modal.Header>

                            <Modal.Body className='container max-width-modal-product'  >
                                <div className='d-flex justify-content-between border' >
                                    <div className='area-photo-small'>
                                        {
                                            product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.map((img, index) => (
                                                <React.Fragment key={index}>
                                                    <div onMouseOver={(e) => { changeFoto(index) }}><img src={img?.thumbnailUrl} /></div>
                                                </React.Fragment>
                                            ))
                                        }
                                    </div>

                                    <div
                                        className='area-fullscreen-product-image'
                                        onMouseEnter={handleMouseEnter}
                                        onMouseLeave={handleMouseLeave}
                                        onMouseMove={handleMouseMove}
                                    >
                                        {
                                            product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images == null ?
                                                (<img src={imgNotFound} />) :
                                                (<img src={product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.[indexImg]?.imageUrl} width={550} />)
                                        }
                                    </div>
                                    {
                                        isZoomVisible && product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images != null ?
                                            (<div className='area-fullscreen-product-image-zoom'>

                                                <div
                                                    className='zoom-area'
                                                    style={{
                                                        backgroundImage: `url('${product?.aplicacoesFraga?.data?.catalogSearchByCode?.nodes?.[0]?.product?.images?.[indexImg]?.imageUrl}')`,
                                                        ...zoomPosition,
                                                    }}
                                                ></div>
                                            </div>) :
                                            (<div className='area-fullscreen-product'>
                                                <br></br>
                                                <br></br>

                                                <div>Vendido por: <strong className='text-secondary'>Auparts Distribuidora</strong></div>
                                                <div>Referência: <strong className='text-secondary'>{product?.Referencia_Produto}</strong> </div>
                                                <div>Fabricante: <strong className='text-secondary'>{product?.Fabricante?.Nome_Fabricante}</strong> </div>
                                                <div>Estoque: <strong className='text-secondary'>{parseInt(product?.Produtos_Estoques?.[0]?.Qtd_Estoque)}</strong></div>
                                                <br></br>


                                                <h1>R$ {formats.formatPrice(product?.Preco_4)}</h1>

                                                {
                                                    sep ? (<></>) :
                                                        (
                                                            parseInt(product?.Produtos_Estoques?.[0]?.Qtd_Estoque) <= 0 ? (
                                                                <div className="text-product">Esgotado!</div>
                                                            ) : (
                                                                <div className='d-flex'>
                                                                    {
                                                                        idProdCurrentCar.includes(product?.Produtos_Estoques?.[0]?.ID_Produto_Estoque) ?
                                                                            (<>
                                                                                <div className=' bg-success icon-add-car-market-ok'>
                                                                                    <BsCartCheckFill onClick={handleCloseCurrentModal} />
                                                                                </div>
                                                                                <span className='desc-add-car'>Item adicionado no carrinho</span>
                                                                            </>
                                                                            ) :
                                                                            (<div onClick={handleAddProdCart} style={{ backgroundColor: "transparent" }} className='d-flex align-items-center   icon-add-car-market'>
                                                                                <Button size="lg" variant='warning' >Comprar</Button>
                                                                            </div>)
                                                                    }
                                                                </div>
                                                            )
                                                        )
                                                }
                                                <br></br>
                                            </div>)
                                    }
                                </div>
                                <br></br>
                                <Container>
                                    {
                                        verifyAplication ?
                                            (<Tabs
                                                defaultActiveKey="Aplicação"
                                                id="uncontrolled-tab-example"
                                                className="mb-3"
                                            >
                                                <Tab eventKey="Aplicação" title="Descrição">
                                                    <div className='area-aplication-product' >
                                                        <Table striped>
                                                            <thead className='table-header'>
                                                                <tr> </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td className="table-cell-loading">{product?.Descricao_Auri}</td>
                                                                </tr>
                                                            </tbody>

                                                        </Table>
                                                    </div>
                                                </Tab>
                                            </Tabs>)
                                            :
                                            (
                                                <Tabs
                                                    defaultActiveKey="Aplicação"
                                                    id="uncontrolled-tab-example"
                                                    className="mb-3"
                                                >
                                                    <Tab eventKey="Aplicação" title="Aplicação">
                                                        <div className='area-aplication-product' >
                                                            <Table striped>
                                                                <thead className='table-header'>
                                                                    <tr>
                                                                        <th>Montadora</th>
                                                                        <th>Veiculo</th>
                                                                        <th>Modelo</th>
                                                                        <th>Motor</th>
                                                                        <th>Config. Motor</th>
                                                                        <th>Ano Inicial</th>
                                                                        <th>Ano Final</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        aplication?.vehicles === undefined ? (
                                                                            <tr>
                                                                                <td className="table-cell-loading">Carregando...</td>
                                                                            </tr>
                                                                        ) : (
                                                                            aplication?.vehicles
                                                                                ?.sort((a, b) => a?.name?.localeCompare(b?.name)) // Ordena alfabeticamente pelo campo "name"
                                                                                ?.map((app, index) => (
                                                                                    <tr key={index}>
                                                                                        <td>{app?.brand}</td>
                                                                                        <td>{app?.name}</td>
                                                                                        <td>{app?.model}</td>
                                                                                        <td>{app?.engineName}</td>
                                                                                        <td>{app?.engineConfiguration}</td>
                                                                                        <td>{app?.startYear}</td>
                                                                                        <td>{app?.endYear}</td>
                                                                                    </tr>
                                                                                ))
                                                                        )
                                                                    }
                                                                </tbody>

                                                            </Table>
                                                        </div>
                                                    </Tab>
                                                    <Tab eventKey="Detalhes" title="Ficha Técnica">
                                                        <div className='area-aplication-product' >

                                                            <h6>Especificações Técnicas</h6>

                                                            {
                                                                aplication?.specifications?.map((spec, index) => (
                                                                    <React.Fragment key={index}>
                                                                        <div className='form-control'> {`${spec?.description}: `}<strong className='text-secondary'>{spec?.value}</strong></div>

                                                                    </React.Fragment>

                                                                ))
                                                            }


                                                        </div>
                                                    </Tab>

                                                    <Tab eventKey="Referencia Cruzada" title="Referência Cruzada">
                                                        <Card ref={produtosSimilaresRef} className='border-0'>
                                                            <Card.Body>

                                                                <div className='similar-product-fullscreen'>
                                                                    {


                                                                        loadCross ?
                                                                            (<>CarregandoWWW...</>)
                                                                            : (<>

                                                                                <Table striped>
                                                                                    <thead className='table-header'>
                                                                                        <tr>
                                                                                            <th>Montadora</th>
                                                                                            <th>Veiculo</th>
                                                                                        </tr>
                                                                                    </thead>
                                                                                    <tbody>
                                                                                        {

                                                                                            aplication?.crossReference?.length == 0 ?
                                                                                                (<tr>
                                                                                                    <td className="table-cell-loading">Carregando...</td>
                                                                                                </tr>
                                                                                                ) :
                                                                                                (
                                                                                                    aplication?.crossReference?.map((app, index) => (
                                                                                                        <tr key={index}>
                                                                                                            <td>{app?.brand?.name}</td>
                                                                                                            <td>{app?.partNumber}</td>

                                                                                                        </tr>
                                                                                                    ))
                                                                                                )
                                                                                        }

                                                                                    </tbody>
                                                                                </Table>

                                                                            </>)

                                                                    }

                                                                </div>

                                                            </Card.Body>
                                                        </Card>
                                                    </Tab>
                                                </Tabs>
                                            )
                                    }
                                </Container>
                                <br></br>
                                <hr></hr>
                            </Modal.Body>
                        </Modal>
                    )
            }

        </>
    )
}

export default Product_Fraga